import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React, { FC } from 'react';

import { Link } from 'src/components/link';
import { LinkTheme } from 'src/components/link/link-types';

import { StyledLinkContainer } from './footer-external-link.styled';

interface Props {
  label: string;
  url: string;
}

export const FooterExternalLink: FC<Props> = (props) => {
  const { label, url } = props;

  return (
    <StyledLinkContainer>
      <Link variant="paragraph2" href={url} maxBreakpoint={Breakpoint.TABLET} $focusTheme={LinkTheme.DARK}>
        {label}
      </Link>
    </StyledLinkContainer>
  );
};
